import React from 'react';
import { Link } from 'react-router-dom';
type BrandProps = {
  tone?: 'dark' | 'light';
};

/**
 * WebsiteForge lockup. The square mark is a reserved slot for the real logo file.
 */
export function Brand({
  tone = 'dark'
}: BrandProps) {
  return <Link to="/" className="group flex items-center gap-3" aria-label="WebsiteForge — home" data-id="element-398" data-mp="l57g8kv4poux">
      <span className="relative grid h-11 w-11 shrink-0 place-items-center overflow-hidden rounded-[10px] bg-navy-800 ring-1 ring-inset ring-white/15" aria-hidden="true" data-id="element-399" data-mp="g7pi7pingu1p">
        <span className="absolute inset-0 bp-fine opacity-80" data-id="element-400" data-mp="18v1vf92x7pic" />
        <span className="absolute left-0 top-0 h-[3px] w-full bg-forge-orange" data-id="element-401" data-mp="13unvyffdxnvx" />
        <span className="relative font-display text-[15px] font-extrabold tracking-tight text-white" data-id="element-402" data-mp="ywmajnuhlcha">WF</span>
      </span>
      <span className="flex flex-col leading-none" data-id="element-403" data-mp="3oly0a3njq2fm">
        <span className={`font-display text-[19px] font-extrabold tracking-tight ${tone === 'dark' ? 'text-white' : 'text-navy-900'}`} data-id="element-404" data-mp="3ojbkxhueyimu">
          Website<span className="text-forge-orange" data-id="element-405" data-mp="2jxukr6q0xkhe">Forge</span>
        </span>
        <span className={`mt-[5px] font-mono text-[9.5px] uppercase tracking-[0.24em] ${tone === 'dark' ? 'text-mist-400' : 'text-navy-600'}`} data-id="element-406" data-mp="2o094ru5fiqa9">
          Custom built since 2002
        </span>
      </span>
    </Link>;
}